import { useState } from 'react';
import Filters from '../Table/Filters';
import SharedButton from '../../global/Button/Button';
import { getFilterLabel } from '../../modules/search/searchGrid/helpers/getFiltersLabels';
import SavedFiltersModal from './SavedFiltersModal';
import { userAppContext } from '../../Context/Context';
import { UserContext } from '../../types';
import Alert from '../../global/Alert/Alert';
import { trackFilterAction } from '../../utils/analytics';
import { usePrivacyPolicy } from '../../hooks/usePrivacyPolicy';
import PrivacyPolicyModal from '../Common/PrivacyPolicyModal';

const SHOW_FILTERS = process.env.REACT_APP_SHOW_FILTERS === 'true';

const ActiveFiltersBar = ({ filters, onRemoveFilter, onClearAll, isEvidence = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);
  const { isAuthenticated, groups } = userAppContext() as unknown as UserContext;
  const { privacyPolicyAccepted, isLoading: isPrivacyLoading, markAsAccepted } = usePrivacyPolicy();

  const isAcademic = groups?.includes('ROLE_ACADEMIC');

  const activeFilters = filters.filter(
    f =>
      f.value !== undefined &&
      f.value !== null &&
      f.value !== '' &&
      !(Array.isArray(f.value) && f.value.length === 0),
  );

  function getLabelsForActiveFilters(activeFilters, filters) {
    return activeFilters.map(activeFilter => {
      const matchingFilter = filters.find(filter => filter.name === activeFilter.name);
      return {
        ...activeFilter,
        label: matchingFilter ? matchingFilter.label : 'Unknown',
      };
    });
  }

  const activeFiltersWithLabels = getLabelsForActiveFilters(activeFilters, Filters);

  const handleApplyFilter = savedFilters => {
    onClearAll();

    if (window.gridRef?.current) {
      window.gridRef.current.setFilterValue(savedFilters);
    }
  };

  const handleSaveSuccess = (message: string) => {
    setSuccessMessage(message);
    setShowSuccessAlert(true);
    setTimeout(() => setShowSuccessAlert(false), 3000);
  };

  const handleManageFiltersClick = () => {
    trackFilterAction('manage_filters_click');

    // Check if privacy policy is accepted
    if (privacyPolicyAccepted === null || privacyPolicyAccepted === false) {
      setShowPrivacyPolicyModal(true);
    } else {
      setIsModalOpen(true);
    }
  };

  const handlePrivacyPolicyAccept = () => {
    markAsAccepted();
    setShowPrivacyPolicyModal(false);
    setIsModalOpen(true);
  };

  const handlePrivacyPolicyClose = () => {
    setShowPrivacyPolicyModal(false);
  };

  if (activeFilters.length === 0) return null;

  return (
    <>
      {showSuccessAlert && <Alert message={successMessage} type="success" />}

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-gray-700">Active Filters ({activeFilters.length})</span>
          <div className="flex gap-2">
            <SharedButton size="xs" onClick={onClearAll}>
              Clear all
            </SharedButton>
            {isAuthenticated && SHOW_FILTERS && !isAcademic && (
              <>
                <SharedButton size="xs" onClick={handleManageFiltersClick} disabled={isPrivacyLoading}>
                  Save filters
                </SharedButton>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-wrap gap-2" id="tags">
          {activeFiltersWithLabels.map((filter, index) => (
            <div key={`${filter.name}-${filter.operator || ''}-${index}`} className="etiquetas etpeq w-auto">
              <span className="text-gray-700 ml-0" onClick={() => onRemoveFilter(filter)}>
                {getFilterLabel(filter)}
              </span>
            </div>
          ))}
        </div>
      </div>

      {isAuthenticated && (
        <>
          <SavedFiltersModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onApplyFilter={handleApplyFilter}
            currentFilters={filters}
            isEvidence={isEvidence}
            onSaveSuccess={handleSaveSuccess}
          />

          <PrivacyPolicyModal
            isOpen={showPrivacyPolicyModal}
            onClose={handlePrivacyPolicyClose}
            onAccept={handlePrivacyPolicyAccept}
          />
        </>
      )}
    </>
  );
};

export default ActiveFiltersBar;
